<template>
  <div class="flex">
    <img v-if="product.name.includes('NF18MESH')" class="h-16 my-6" src="https://uniti-bpo-website-assets.assets.unitiinternet.com/images/nf18mesh.png" />
    <div class="flex items-center" v-if="product.name.includes('NF18MESH-01') || product.name.includes('NF18MESH-02')">
      <PlusIcon class="ml-2 h-6 w-6 text-gray-900"></PlusIcon>
      <img class="h-16 my-6 ml-2" src="https://uniti-bpo-website-assets.assets.unitiinternet.com/images/nf18mesh-extender.png" />
      <img v-if="product.name.includes('NF18MESH-02')" class="h-16 my-6 ml-4" src="https://uniti-bpo-website-assets.assets.unitiinternet.com/images/nf18mesh-extender.png" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import { PlusIcon } from '@heroicons/vue/outline';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}

defineProps<{
  product: Product
}>();
</script>
